import { render, staticRenderFns } from "./SearchInfo.vue?vue&type=template&id=7c64ca89&scoped=true&"
import script from "./SearchInfo.vue?vue&type=script&lang=js&"
export * from "./SearchInfo.vue?vue&type=script&lang=js&"
import style0 from "./SearchInfo.vue?vue&type=style&index=0&id=7c64ca89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c64ca89",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
